<template>
  <div class="write-demo">
    <div class="big-word" id="tian"></div>
    <!-- <div class="title">{{ $t("write_demo") }}</div> -->
    <div class="num">{{ $t("num_bihua") + "： " + ziWritingFullInfo.strokes }}</div>
    <div class="write-show" @click="writerAction">
      <SvgIcon type="plain-frame" style="width: 18px; height: 18px; color: #fff" />
      <div>{{ $t("write_demo") }}</div>
    </div>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import HanziWriter from "hanzi-writer";
import axios from "axios";
import { IS_CHINA } from "@/config";
export default {
  components: {
    SvgIcon,
  },
  props: {
    ziWritingFullInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      writer: null,
    };
  },
  watch: {
    //书写动画的汉字
    "ziWritingFullInfo.word": {
      handler() {
        this.createWriter();
      },
      deep: true,
    },
  },
  mounted() {
    this.createWriter();
  },
  computed: {
    isChina() {
      return IS_CHINA;
    },
  },
  methods: {
    // 创建writer
    createWriter() {
      if (this.writer === null) {
        let _this = this;
        this.writer = HanziWriter.create("tian", this.ziWritingFullInfo.word, {
          width: 118,
          height: 118,
          padding: 10,
          charDataLoader: function (char, onComplete) {
            axios
              .get(
                (_this.isChina ? _this.$store.state.publicUrl.mockPublicUrl : "https://public.hskmock.com") +
                  "/hanzi.static/" +
                  char +
                  ".json",
                { timeout: 60000 },
              )
              .then((charData) => {
                onComplete(charData.data);
              })
              .catch((err) => {
                console.log(err);
              });
          },
        });
      } else {
        console.log(this.ziWritingFullInfo.word);
        this.writer.setCharacter(this.ziWritingFullInfo.word);
      }
    },
    // 演示笔画
    writerAction() {
      this.writer.animateCharacter();
    },
  },
};
</script>

<style scoped lang="scss">
.write-demo {
  width: 952px;
  height: 144px;
  background: #fafafb;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  .big-word {
    width: 120px;
    height: 120px;
    font-family: "KaiTi";
    background: #fff;
    font-size: 88px;
    text-align: center;
    line-height: 120px;
    margin-left: 12px;
    margin-top: 12px;
    border: 0.625px solid #e7e7ed;
    border-radius: 5px;
    background: url(@/assets/images/tianzige.png);
  }
  .title {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    top: 20px;
    left: 152px;
  }
  .num {
    font-size: 12px;
    line-height: 20px;
    position: absolute;
    top: 36px;
    left: 152px;
    color: #696974;
  }

  .write-show {
    width: 192px;
    height: 44px;
    background: #faae56;
    border-radius: 4px;
    position: absolute;
    top: 70px;
    left: 152px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    div {
      font-weight: 600;
      font-size: 14px;
      color: #ffffff;
      margin-left: 8px;
    }
  }
}
</style>
